import React from 'react'
import { Box, Stack, AccordionDetails } from '@mui/material'
import {
  NestedAccordion,
  LineContainer,
  CustomAccordion,
  CustomAccordionSummary,
  ExpandIcon,
  AccountName,
  LeafNodeCounter,
  CountBadge,
  CounterLine,
  MainLineStack,
  NestedLineStack,
  FlexBox,
  LastChildBox,
  Line
} from './styles/accounts.styles'

interface Account {
  id: string
  name: string
  children: Account[]
}

interface NestedAccountProps {
  account: Account
  level: number
  parentIndex: number
  parentArray: Account[]
  getTotalLeafNodesCount: (account: Account) => number
  shouldExpandByDefault: (account: Account) => boolean
}

const NestedAccount: React.FC<NestedAccountProps> = ({
  account,
  level = 0,
  parentIndex = 0,
  parentArray = [],
  getTotalLeafNodesCount,
  shouldExpandByDefault
}) => {
  return (
    <NestedAccordion key={account.id}>
      {level > 0 && (
        <LineContainer isOnlyChild={parentArray.length === 1} level={level}>
          <MainLineStack direction="row">
            <Stack sx={{ flex: 1 }}>
              <FlexBox />
            </Stack>
            <Stack sx={{ flex: 1 }}>
              <Line />
              {parentIndex === parentArray.length - 1 ? (
                <LastChildBox />
              ) : (
                <Line />
              )}
            </Stack>
          </MainLineStack>
          {level > 1 && (
            <NestedLineStack direction="row">
              <Stack sx={{ flex: 1 }}>
                <FlexBox />
              </Stack>
              <Stack sx={{ flex: 1 }}>
                <Line />
                <Line />
              </Stack>
            </NestedLineStack>
          )}
        </LineContainer>
      )}
      
      <CustomAccordion defaultExpanded={shouldExpandByDefault(account)}>
        <CustomAccordionSummary
          expandIcon={
            account.children?.length > 0 ? (
              <ExpandIcon>
                <i className="fa-light fa-chevron-up" />
              </ExpandIcon>
            ) : null
          }>
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            <AccountName level={level}>{account.name}</AccountName>
            {account.children?.length > 0 && (
              <LeafNodeCounter>
                <CounterLine />
                <CountBadge>{getTotalLeafNodesCount(account)}</CountBadge>
              </LeafNodeCounter>
            )}
          </Box>
        </CustomAccordionSummary>
        {account.children?.length > 0 && (
          <AccordionDetails sx={{ p: 0, pl: '18px' }}>
            {account.children.map((childAccount, index) => (
              <NestedAccount
                key={childAccount.id}
                account={childAccount}
                level={level + 1}
                parentIndex={index}
                parentArray={account.children}
                getTotalLeafNodesCount={getTotalLeafNodesCount}
                shouldExpandByDefault={shouldExpandByDefault}
              />
            ))}
          </AccordionDetails>
        )}
      </CustomAccordion>
    </NestedAccordion>
  )
}

export default NestedAccount

